/** Default error message. */
export const DefaultMessage = 'Something bad happened.';
